export default ({ request }) => ({

  scmCategoryListApi(data) {
    return request({
      url: '/digitalCenter/scmCategory/list',
      method: 'post',
      data
    })
  },
  scmCategoryOptionApi(data) {
    return request({
      url: '/digitalCenter/scmCategory/scmCategoryDtoList',
      method: 'post',
      data
    })
  },
  scmCategoryDetailApi(data) {
    return request({
      url: '/digitalCenter/scmCategory/detail',
      method: 'post',
      data
    })
  },
  scmCategorySaveApi(data) {
    return request({
      url: '/digitalCenter/scmCategory/save',
      method: 'post',
      data
    })
  },
  scmCategoryUpdateStatusApi(data) {
    return request({
      url: '/digitalCenter/scmCategory/updateStatus',
      method: 'post',
      data
    })
  }
})
